/* System defined core library */
import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

/* User defined library/components */
import { SelectedExamDetailService } from '../../../../scheduling/shared/services/selected-exam-detail.service';
import { CultureService } from '../../../services/culture.service';

/* User defined enums/constants */
import { LanguageCultureCodes } from '../../../constants/scheduling.constant';


@Component({
  selector: 'navbar-lang',
  templateUrl: './navbar-lang.component.html',
  styleUrls: ['./navbar-lang.component.scss']
})
export class NavbarLang {
  /* User defined private/public variables */
  public languages: any[] = [];
  public selectedLanguage: string = '';

  /* Service subscriptions */
  selectedLanguage$: Subscription;
  translateLanguage$: Subscription;

  /* Constructor declaration with required injected services */
  constructor(
    private cultureService: CultureService,
    private selectedExamDetailService: SelectedExamDetailService,
    private translate: TranslateService
  ) {
    translate.setDefaultLang(this.selectedExamDetailService.defaultLanguageCode);
    this.translateLanguage$ = selectedExamDetailService.languageCode.subscribe(
      languageCode => {
        translate.use(languageCode);
        LanguageCultureCodes.filter((elm) => {
          if (elm.key === languageCode) {
            this.selectedLanguage = elm.lang;
            this.selectedExamDetailService.selectedLanguageCode = elm.key;
          }
        });
      });
  }

  /* Initialize the component & call required methods when component loaded first time. */
  ngOnInit() {
    this.languages = LanguageCultureCodes.map(elm => ({ code: this.cultureService.mapLanguageCodeToISO(elm.key), lang: elm.lang, translation: elm.translation }));
    this.selectedLanguage = this.selectedExamDetailService.selectedLanguage;
  }

  /* set language, resourcefileculture in service based on language selected from drop down */
  changeLanguage(language: any): void {
    let selectedLanguage: any;
    selectedLanguage = LanguageCultureCodes.filter(elm => elm.lang === language.lang);
    if (selectedLanguage.length) {
      this.selectedExamDetailService.setLanguageCode(selectedLanguage[0].key);
      this.selectedExamDetailService.setResourceCulture(selectedLanguage[0].resourceFileCulture);
      this.selectedExamDetailService.selectedLanguage = selectedLanguage[0].lang;
      this.selectedExamDetailService.selectedLanguageCode = selectedLanguage[0].key;
    }
  }

  /* get CSS style class based on client code */
  getClass() {
    return this.selectedExamDetailService.clientCode ? this.selectedExamDetailService.clientCode.toLowerCase() : '';
  }
}
